import { atom } from 'jotai'
import forEach from 'lodash/forEach'

import { gridStateAtomFamily } from './gridStateFamilyAtom'

export const setColumnVisibilityAtom = atom<null, { id: string; field: string; visible: boolean }>(
  null,
  (get, set, { id, field, visible }) => {
    const gridStateAtom = gridStateAtomFamily(id)

    const prev = get(gridStateAtom)

    if (prev.visibilities[field] !== visible) {
      set(gridStateAtom, {
        ...prev,
        visibilities: {
          ...prev.visibilities,
          [field]: visible,
        },
      })
    }
  },
)

export const setAllColumnsVisibleAtom = atom<null, { id: string }>(null, (get, set, { id }) => {
  const gridStateAtom = gridStateAtomFamily(id)

  const prev = get(gridStateAtom)
  const allVisibilities = {}
  forEach(prev.visibilities, (_, key) => {
    allVisibilities[key] = true
  })

  set(gridStateAtom, {
    ...prev,
    visibilities: {
      ...allVisibilities,
    },
  })
})
